import comHeader from '../../../components/com-header.vue';
import comFooter from '../../../components/com-footer.vue';
import {verify} from '../../../assets/js/tools.js';
export default{
    name:'Register',
    data(){
        var checkuserName = (rule, value, callback) => {
            // var x = /^[A-Za-z0-9]{1,8}$/;
            if (!value) {
              return callback(new Error('用户名不能为空'));
            }
            if(value.length<1||value.length>8){
                return callback(new Error('用户名长度为1-8位'));
              }
            if(verify('userName',value)){
                return callback();
            }else{
                return callback(new Error('用户名格式为字母或数字'));
            }
            
            
        };
        var checkPassword = (rule, value, callback) => {
            // var x = /^([A-Za-z\d]|[@\$!%\*#\?&\.]){6,10}$/;
            if (!value) {
              return callback(new Error('密码不能为空'));
            }
            if(value.length<6||value.length>10){
              return callback(new Error('密码长度为6-10位'));
            }
            if(verify('password',value)){
                return callback();
            }else{
                return callback(new Error('密码格式为数字、字母、@$!%*#?&.'));
            }
        };
        var checkEmail=(rule,value,callback)=>{
            if(verify('email',value)){
                return callback();
            }else{
                return callback(new Error('请输入正确的邮箱'));
            }
        };
        return{
            form:{
                userName:'',
                password:'',
                confirmPassword:'',
                email:'',
                yzm:'',
                checkCode:'',
            },
            radio:false,
            buttonLoading:false,
            buttonText:'发送验证码',
            rules: {
                userName: [
                    { validator: checkuserName, trigger: 'blur' }
                ],
                password: [
                    { validator: checkPassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { validator: checkPassword, trigger: 'blur' }
                ],
                email:[
                    {validator: checkEmail, trigger: 'blur'}
                ]
              }
        }
    },
    components:{
        comHeader,
        comFooter,
    },
    methods:{
        getYzm(){
            if(this.form.email&&verify('email',this.form.email)){
                this.countDown(60);
                this.postForm(this.api.getYzm,{email:this.form.email}).then(res=>{
                    if(res.result==200){
                        this.form.checkCode=res.data;
                    }
                }).catch(err=>{
                    this.$message.warning(err.msg);
                });
            }else{
                this.$message.warning('请输入正确邮箱');
            }
        },
        countDown (time) {
            if (time === 0) {
                this.buttonLoading = false;
                this.buttonText = "发送验证码";
                return;
            } else {
                this.buttonLoading = true;
                this.buttonText = time;
                time--;
            }
            setTimeout(()=> {
            this.countDown(time)
            }, 1000)
        },
        onSubmit(){
            if(!this.form.userName){
                this.$message.warning('请填写用户名');
                return;
            }
            if(!this.form.password){
                this.$message.warning('请输入密码');
                return;
            }
            if(!this.form.confirmPassword){
                this.$message.warning('请再次输入密码');
                return;
            }
            if(!this.form.confirmPassword){
                this.$message.warning('请再次输入密码');
                return;
            }
            if(this.form.confirmPassword!=this.form.password){
                this.$message.warning('请两次密码一致');
                return;
            }
            if(!this.form.email){
                this.$message.warning('请输入邮箱');
                return;
            }
            if(!this.form.yzm){
                this.$message.warning('请输入邮箱验证码');
                return;
            }
            if(!this.radio){
                this.$message.warning('请阅读并同意用户注册协议');
                return;
            }
            var body={
                email:this.form.email,
                password:this.form.password,
                userName:this.form.userName,
                yzm:this.form.yzm,
            };
            this.postUrl(this.api.register,body).then(res=>{
                if(res.result==200){
                    this.$message.success('注册成功');
                }else{
                    this.$message.error(res.msg);
                }
            }).catch(err=>{
                this.$message.error(err.msg);
            });
            
        }
    }
}